import { render } from "./Information.vue?vue&type=template&id=0aa7272c&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import "./Information.vue?vue&type=style&index=0&id=0aa7272c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa7272c"]])

export default __exports__